import { defineNuxtPlugin, useNotification } from '#imports'

export default defineNuxtPlugin({
    name: 'chunk-error-handler',
    setup(nuxtApp) {
        const { showNotification } = useNotification()
        const RELOAD_KEY = 'chunk-error-reload-attempted'
        let isHandlingChunkError = false

        // Clear reload flag if enough time has passed since the reload
        // This prevents infinite loops if chunk errors occur immediately after reload
        if (sessionStorage.getItem(RELOAD_KEY)) {
            try {
                const reloadData = JSON.parse(sessionStorage.getItem(RELOAD_KEY) || '{}')
                const timeSinceReload = Date.now() - (reloadData.timestamp || 0)

                // Only clear if more than 5 seconds have passed since reload
                if (timeSinceReload > 5000) {
                    sessionStorage.removeItem(RELOAD_KEY)
                }
            } catch {
                // Invalid data format, clear it
                sessionStorage.removeItem(RELOAD_KEY)
            }
        }

        // Listen for Nuxt's chunk errors (catches Vite preload errors from Lazy components)
        nuxtApp.hook('app:chunkError', () => {
            handleChunkError()
        })

        function handleChunkError() {
            // Prevent duplicate handling if multiple chunks fail in parallel
            if (isHandlingChunkError) {
                return
            }
            isHandlingChunkError = true

            const hasAttemptedReload = sessionStorage.getItem(RELOAD_KEY)

            if (!hasAttemptedReload) {
                // First attempt - reload silently with timestamp
                sessionStorage.setItem(RELOAD_KEY, JSON.stringify({
                    timestamp: Date.now()
                }))

                // Reload the page to fetch fresh assets
                window.location.reload()
            } else {
                // Check if last reload was recent (potential infinite loop)
                try {
                    const reloadData = JSON.parse(hasAttemptedReload)
                    const timeSinceReload = Date.now() - (reloadData.timestamp || 0)

                    if (timeSinceReload < 5000) {
                        // Reload was very recent - likely infinite loop, show error
                        sessionStorage.removeItem(RELOAD_KEY)

                        showNotification(
                            'We encountered an error loading the page. Please clear your browser cache and try again.',
                            'error',
                            true // Keep alive - requires manual close
                        )
                    } else {
                        // Reload was long ago - safe to try again (new deployment)
                        sessionStorage.setItem(RELOAD_KEY, JSON.stringify({
                            timestamp: Date.now()
                        }))

                        window.location.reload()
                    }
                } catch {
                    // Invalid data - treat as failed reload
                    sessionStorage.removeItem(RELOAD_KEY)

                    showNotification(
                        'We encountered an error loading the page. Please clear your browser cache and try again.',
                        'error',
                        true // Keep alive - requires manual close
                    )
                }
            }
        }
    }
})
